import React, {useState, useEffect} from 'react';
import { Row, Col, Card, Form, Button} from 'react-bootstrap';
import { Link} from "react-router-dom";
import axios from 'axios';
//import { Navigate } from 'react-router-dom';
import Layout from '../../layout/fullpage';
import jwt_decode from "jwt-decode";
import Spinner from 'react-bootstrap/Spinner';
import { Alert } from 'react-bootstrap';
import {Logo} from '../../components';

import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";


const AuthLoginPage= () => {
   
    const navigate = useNavigate();

    const [isProcessing, setisProcessing] = useState(false)
    const [userValid, setuserValid] = useState(false)
    const [formValue, setformValue] = useState({    
        email:'',
        password:''
      })
    const [error, setError] = useState("")


    const { setToken, user, setUser, setLoadingApp, SiteConfig, setSiteConfig } = useContext(AppContext);

    
    useEffect(() => {

        //console.log(userValid && user && SiteConfig.CURRENT_USER_NAME);

        if (userValid && user && SiteConfig.CURRENT_USER_NAME) {
          navigate("/", { replace: true });
        }
      }, [userValid, user, SiteConfig, navigate]);

    
    const handleChange = (event) => {
        setformValue({
          ...formValue,
          [event.target.id]: event.target.value
        });
        //console.log(event.target.id +'=='+ event.target.value)
      }
    
      async function handleSubmit(event) {
        event.preventDefault(); // <-- important!
        setisProcessing(true);
        setError(""); // clear any previous errors
    
        const frmFormData = new FormData();
        frmFormData.append("email", formValue.email);
        frmFormData.append("password", formValue.password);
    
        try {
            const headers = {
                'Content-Type': 'application/json'
            };
    
            const sURL = SiteConfig.API_BASE_URL + "Token";

            //console.log(sURL);
            //console.log(SiteConfig);
            //console.log("========================");

            const response = await axios.post(sURL, frmFormData, { headers });
    
            //console.log(response);

            if (response.data) {

                // localStorage.clear();
                // localStorage.setItem(process.env.REACT_APP_API_AUTH_TOKEN, response.data);

                // Clear all cookies (optional, or remove just the specific one)
                Cookies.remove(process.env.REACT_APP_API_AUTH_TOKEN, { path: '/' });

                // Set token in a cookie
                Cookies.set(process.env.REACT_APP_API_AUTH_TOKEN, response.data, {
                expires: 1, // expires in 1 day (customize as needed)
                secure: true, // only send over HTTPS
                sameSite: 'Strict', // or 'Lax', depending on your use case
                path: '/', // make it available across your app
                });
                    
                const token = response.data;
                setToken(token);

                const decoded = jwt_decode(token);    
                
                setUser(decoded);
    
               
                const SiteConfigLocal = {
                    CURRENT_USER_NAME : decoded.UserName,
                    CURRENT_USER_EMAIL : decoded.UserEmail,
                    CURRENT_USER_ID : decoded.UserId,
                    CURRENT_USER_ROLE : (decoded.UserRole === "1" ? "admin" : "user"),
                    CURRENT_USER_TENANT_ID : decoded.TenantID,
                    CURRENT_USER_TENANT_NAME : decoded.TenantName,
                    CURRENT_USER_TENANT_DISPLAY_NAME : decoded.TenantDisplayName,
                    CURRENT_USER_TENANT_EMAIL : decoded.TenantEmail,
                    CURRENT_USER_TENANT_ADDRESS :  decoded.TenantAddress,
                    CURRENT_USER_TENANT_EXP : decoded.exp,
                    API_BASE_URL : process.env.REACT_APP_API_BASE_URL,
                    API_NOTIFICATION_HUB_URL : process.env.REACT_APP_API_NOTIFICATION_HUB_URL,
                    API_AUTH_TOKEN: process.env.REACT_APP_API_AUTH_TOKEN,
                  }          
                  setSiteConfig(SiteConfigLocal);


                setuserValid(true); // success: redirect

                navigate("/", { replace: true });
                // 3. Hard reload the app (recommended for clean state)
                window.location.href = "/";    

            }
        } catch (error) {
            //console.log("Login error:", error);
            setuserValid(false);
    
            // Extract and show API error message or fallback
            if (error.response && error.response.data) {
                setError(error.response.data.message || error.response.data || "Login failed. Please try again.");
            } else {
                setError("An unexpected error occurred. Please try again.");
            }
        } finally {
            setisProcessing(false); // always stop spinner
        }
    }
    

    // if (userValid && !isProcessing && user && SiteConfig.CURRENT_USER_NAME) {
    //    // return <Navigate to="/" />
    //     navigate("/", { replace: true });
    //   }
    // else 
        
  return (
    <>    
        <Layout title="Login" centered>
            <div className="container p-2 p-sm-4">
                <Card className="overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh">
                    <Row className="g-0 flex-lg-row-reverse">
                        <Col lg="5">
                            <Card.Body className="h-100 d-flex flex-column justify-content-center">
                                <div className="nk-block-head text-center">
                                    <div className="nk-block-head-content">
                                        <h3 className="nk-block-title mb-1">HMCarePlanner Login</h3>
                                        <p className="small">Please log-in to your account.</p>
                                    </div>
                                </div>
                                <Form onSubmit={handleSubmit}>
                                    <Row className="gy-3">
                                        <Col className="col-12">
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="email">Email</Form.Label>
                                                <div className="form-control-wrap">
                                                    <Form.Control type="text" id="email" placeholder="Enter email" required onChange={handleChange}/>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-12">
                                            <Form.Group className="form-group">
                                                <Form.Label htmlFor="password">Password</Form.Label>
                                                <div className="form-control-wrap">
                                                    <Form.Control type="password" id="password" placeholder="Enter password" required onChange={handleChange}/>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col className="col-12">
                                            <div className="d-flex flex-wrap justify-content-between">
                                                <Form.Check 
                                                    className="form-check-sm"
                                                    type="checkbox"
                                                    id="rememberMe"
                                                    label="Remember Me"
                                                />
                                                <Link to="/auths/auth-reset" className="small">Forgot Password?</Link>
                                            </div>
                                        </Col>
                                        <Col className="col-12">
                                            <div className="d-grid">
                                                <Button type="submit" disabled={isProcessing}>
                                                    {isProcessing && 
                                                    <>
                                                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                                                    <span className="ms-1">Signing in ...</span>
                                                    </>
                                                    }
                                                    {!isProcessing && <>Login to account</>}
                                                </Button>                                                
                                            </div>
                                        </Col>
                                        <Col className="col-12">
                                        {error && (
                                            <Alert variant="danger" className="mt-2">
                                            {error}
                                            </Alert>
                                        )}
                                        </Col>
                                    </Row>
                                </Form>                             
                            </Card.Body>
                        </Col>
                        <Col lg="7">
                            <Card.Body className="bg-darker is-theme has-mask has-mask-1 h-100 d-flex flex-column justify-content-end">
                                <div className="mask mask-1"></div>
                                <div className="brand-logo">
                                    <Logo />
                                </div>
                                <div className="row">
                                    <div className="col-sm-11">
                                        <div className="mt-4">
                                            <div className="h1 title mb-3">Welcome to HMCarePlanner</div>
                                            <p>Access, Manage and Complete Your Care Services </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5">                                  
                                    <p className="small mt-2">© {new Date().getFullYear()} HMCarePlanner</p>
                                </div>
                            </Card.Body>
                        </Col>
                    </Row>
                </Card>
            </div>
        </Layout>
    </>
  );
}

export default AuthLoginPage;
